module.exports = __webpack_public_path__ + "img/image-humor.1da3dc40.png";